'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import OpenMenuIcon from '@material-ui/icons/Menu';
import CloseMenuIcon from '@material-ui/icons/Close';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import EtablishmentSelection from 'Components/Back/EtablishmentSelection';
import LogoutIcon from 'Icons/LogoutIcon';
import Sidebar from 'Components/Navigation/Sidebar';
const {
  app,
  qwest
} = window;
export default class Back extends Component {
  state = {
    is_sidebar_open: true,
    hotel_selection_open: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      is_sidebar_open: localStorage.getItem('is_sidebar_open') === 'true'
    });
    app.push({
      event: 'documentClick',
      cb: component.handleDocumentClick
    });
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'documentClick',
      cb: component.handleDocumentClick
    });
  }
  captureClick = e => {
    const component = this,
      props = this.props,
      state = this.state;
    app.emit({
      event: 'documentClick',
      source: 'Layout'
    });
  };
  handleDocumentClick = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!['AdminHotelSelection', 'HotelSelectionToggle'].includes(source)) {
      component.setState({
        hotel_selection_open: false
      });
    }
  };
  toggleSideBar = e => {
    const component = this,
      props = this.props,
      state = this.state;
    localStorage.setItem('is_sidebar_open', !state.is_sidebar_open);
    component.setState({
      is_sidebar_open: !state.is_sidebar_open
    });
  };
  logout = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/logout').then(function (xhr, response) {
      // Update user permissions now that user is disconnected
      app.emit({
        event: 'sessionNeedsRefresh',
        source: 'logout'
      });
      app.navigateTo(response.pathname);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  toggleHotelSelection = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.stopPropagation();
    app.emit({
      event: 'documentClick',
      source: 'HotelSelectionToggle'
    });
    component.setState({
      hotel_selection_open: !state.hotel_selection_open
    });
  };
  render = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const MenuIcon = state.is_sidebar_open ? CloseMenuIcon : OpenMenuIcon;
    const is__admin = app.state.session?.user?.roles?.includes?.('admin');
    let output = /*#__PURE__*/React.createElement("div", {
      className: "back-page",
      onClick: component.captureClick
    }, /*#__PURE__*/React.createElement(AppBar, {
      position: "fixed"
    }, /*#__PURE__*/React.createElement("div", {
      className: state.is_sidebar_open ? "o-header" : "o-header o-header--full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-header__menu-actions"
    }, /*#__PURE__*/React.createElement(IconButton, {
      color: "inherit",
      "aria-label": "Menu",
      onClick: component.toggleSideBar
    }, /*#__PURE__*/React.createElement(MenuIcon, null)), /*#__PURE__*/React.createElement(Typography, {
      color: "inherit",
      classes: {
        root: 'o-header__title'
      }
    }, "Menu")), /*#__PURE__*/React.createElement("div", {
      className: "o-header__center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-header__title"
    }, props.page_title), is__admin ? /*#__PURE__*/React.createElement(Button, {
      onClick: component.toggleHotelSelection,
      className: "o-header__etablishment"
    }, app.state.session?.user?._etablishment?.name) : undefined), /*#__PURE__*/React.createElement(LogoutIcon, {
      onClick: component.logout,
      className: "o-header__logout\r u-margin-right-10 u-margin-left-10"
    }))), /*#__PURE__*/React.createElement(Sidebar, _extends({}, props, {
      open: state.is_sidebar_open
    })), /*#__PURE__*/React.createElement("div", {
      className: "page-content"
    }, props.children), is__admin ? /*#__PURE__*/React.createElement(EtablishmentSelection, {
      visible: state.hotel_selection_open,
      close: () => component.setState({
        hotel_selection_open: false
      })
    }) : undefined);
    return output;
  };
}
